<template>
  <router-link
    :to="eventRouterLink"
    class="fc-day-grid-event fc-h-event fc-event fc-start fc-end"
    :class="[eventStatusClass]"
    :title="eventDescription"
    @click.native="handleEventClickCallback">
    <div class="fc-content">
      <span class="fc-time">{{ eventStartTime }}</span>
      <span class="fc-title">{{ eventDescription }}</span>
    </div>
  </router-link>
</template>

<script>
import { helpers } from 'mixins/calendar'
import $ from 'jquery'

export default {
  mixins: [helpers],

  props: {
    event: {
      required: true,
      type: Object
    }
  },

  mounted () {
    $(this.$el).tooltip({
      container: 'body'
    })
  },

  methods: {
    handleEventClickCallback () {
      $(this.$el).tooltip('hide')
    }
  }
}
</script>
